import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { useUpdateIntegration } from '@modules/integrationsV2/hooks';
import { IntegrationChannelType } from 'generated/graphql';
import { useCallback } from 'react';
import { IsLoading } from 'v2/core/repository/edge-server/types';

interface DisableIntegrationOptions {
  channelType: IntegrationChannelType;
  onCompleted: () => void;
  successMessage?: string;
}

export const useDisableIntegration = ({
  channelType,
  onCompleted,
  successMessage = `${channelType} Integration Disabled`,
}: DisableIntegrationOptions) => {
  const [updateIntegration, { status }] = useUpdateIntegration({
    channelType,
    integrationType: undefined,
    onCompleted: () => {
      showSuccessNotification({
        contentComponent: successMessage,
        props: {},
      });
      onCompleted();
    },
  });

  const { showSuccessNotification } = useNotificationContext();

  const disableIntegration = useCallback(
    async (integrationID: string) => {
      await updateIntegration({
        integrationID: integrationID,
        isActive: true,
        updateData: {},
        disableIntegration: true,
      });
    },
    [updateIntegration],
  );

  return { disableIntegration, isLoading: IsLoading(status) };
};
